import { Component, EventEmitter, forwardRef, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Destroyer } from 'src/app/core/abstract/destroyer';

@Component({
  selector: 'craft-number-input',
  templateUrl: './craft-number-input.component.html',
  styleUrls: ['./craft-number-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CraftNumberInputComponent),
      multi: true,
    },
  ],
})
export class CraftNumberInputComponent extends Destroyer implements ControlValueAccessor, OnChanges {
  @Output() public update = new EventEmitter<number | null>();

  @Input() public min?: number;
  @Input() public max?: number;
  @Input() public allowNull = false;
  @Input() public showButtons = false;
  @Input() public isDisabled = false;
  @Input() public placeholder = 'Set';
  @Input() public decimalSeparator = '.';
  @Input() public value?: string | number | null;

  public onTouched = () => {};
  public onChange = (_?: number | null) => {};

  public val: string;

  constructor() {
    super();
  }

  private get emptyValue() {
    return this.allowNull ? null : this.min ?? 0;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.value) {
      this.val = String(changes.value.currentValue ?? '');
    }
  }

  public writeValue(val: any): void {
    this.val = String(val ?? '');
  }

  public registerOnChange(fn: (_?: number | null) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  public onBlur(val: string) {
    this.val = val;
    const num = val ? +val : this.emptyValue;
    this.changeValue(num);
  }

  public plus(): void {
    const num = +this.val + 1;
    this.val = String(num);
    this.changeValue(num);
  }

  public minus(): void {
    const num = +this.val - 1;
    this.val = String(num);
    this.changeValue(num);
  }

  private changeValue(val: number | null) {
    this.onChange(val);
    this.update.next(val);
    this.onTouched();
  }
}
